import { render } from "./PricingStyleOne.vue?vue&type=template&id=53b69ca7&ts=true"
import script from "./PricingStyleOne.vue?vue&type=script&lang=ts"
export * from "./PricingStyleOne.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__